import { render, staticRenderFns } from "./advertisementCard.vue?vue&type=template&id=6799133c&scoped=true&"
import script from "./advertisementCard.vue?vue&type=script&lang=js&"
export * from "./advertisementCard.vue?vue&type=script&lang=js&"
import style0 from "./advertisementCard.vue?vue&type=style&index=0&id=6799133c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6799133c",
  null
  
)

export default component.exports